import * as React from 'react';
import { HylyPropertyConfiguration } from '../../../../../api/PropertyIntegration';
import CollapsibleCard from '../../../../common/CollapsibleCard';
import CheckboxLabeled from '../../../../common/form/CheckboxLabeled';
import FormInput from '../../../../common/form/Input';
import { userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../../utilities/identity';

interface Props {
    config?: HylyPropertyConfiguration;
    update: (newConfig?: HylyPropertyConfiguration) => void;
}

const HylyConfigurationSection = (props: Props) => {
    const isUser =
    userIsCompanyManageUser() ||
    userIsPropertyManageUser() ||
    userIsSystemManageUser();
    return(
    <CollapsibleCard
        cardTitle="Hyly Configuration"
        cardOpen={!!props.config}
        onCardOpenChange={open =>{
            if (isUser)  return;
            props.update(open ? { hylyCommunityId: '', useForAvailability: false } : undefined)
        }}
    >
        <div>
            {props.config && (
                <>
                    <FormInput
                        labelProps={{
                            labelText: 'Community ID',
                            invalidText: 'Please enter a Hyly Community ID'
                        }}
                        inputProps={{
                            id: 'hyly-community-id',
                            name: 'hylyCommunityId',
                            value: props.config.hylyCommunityId,
                            type: 'string',
                            required: true,
                            disabled: isUser
                        }}
                        onChange={(_name, value) =>
                            !isUser && props.update({
                                ...props.config!,
                                hylyCommunityId: value.toString()
                            })
                        }
                    />
                    <CheckboxLabeled
                        labelProps={{
                            labelText:
                                'Use Property Hyly Calendar for Tour Scheduling Availability?'
                        }}
                        toggle={true}
                        onChange={() =>
                            !isUser && props.update({
                                ...props.config!,
                                useForAvailability: !props.config!.useForAvailability
                            })
                        }
                        inputProps={{
                            id: 'hyly-calendar',
                            name: 'hyly-calendar',
                            checked: props.config.useForAvailability,
                            disabled: isUser
                        }}
                    />
                </>
            )}
        </div>
    </CollapsibleCard>
);
};
export default HylyConfigurationSection;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/HylyConfigurationSection.tsx